export const HOME_MATCH_PREFERENCES_MODAL_DISMISSED = "homeMatchPreferencesModalDismissed";
export const PHONE_NUMBER_MODAL_DISMISSED = "phoneNumberModalDismissed";
export const PHONE_VERIFICATION_MODAL_DISMISSED = "phoneVerificationModalDismissed";
export const APPLICATION_LOCAL_STORAGE_KEY = "applicationFormSavedInfo";
export const KM_TURNSTILE_SIMULATION_STORAGE_KEY = "kmTurnstileSimulation";
export const PROFILE_PICTURE_AUTH_KIND = "profilePictureAuthKind";

/**
 * Home match prelead rejection/acceptance triggers invalidation of the prelead list based on a queue and it will not be updated immediately. We need to temporarily store hidden preleads ids to avoid showing them again
 */
export const HOME_MATCH_HIDDEN_PRELEADS_IDS = "homeMatchHiddenPreleadsIds";

/** Device-level; do not clear on logout. */
export const KM_GALLERY_SWIPE_ONBOARDING_SEEN = "kmGallerySwipeOnboardingSeen";

/** Device-level; do not clear on logout. */
export const FAVORITES_REMOVE_FROM_COMPARISON_WARNING_DISMISSED = "favoritesRemoveFromComparisonWarningDismissed";
export const HOME_MATCH_PREFERENCES_MODAL_DISMISSED = "homeMatchPreferencesModalDismissed";
export const PHONE_NUMBER_MODAL_DISMISSED = "phoneNumberModalDismissed";
export const PHONE_VERIFICATION_MODAL_DISMISSED = "phoneVerificationModalDismissed";
export const APPLICATION_LOCAL_STORAGE_KEY = "applicationFormSavedInfo";
export const KM_TURNSTILE_SIMULATION_STORAGE_KEY = "kmTurnstileSimulation";
export const PROFILE_PICTURE_AUTH_KIND = "profilePictureAuthKind";

/**
 * Home match prelead rejection/acceptance triggers invalidation of the prelead list based on a queue and it will not be updated immediately. We need to temporarily store hidden preleads ids to avoid showing them again
 */
export const HOME_MATCH_HIDDEN_PRELEADS_IDS = "homeMatchHiddenPreleadsIds";

/** Device-level; do not clear on logout. */
export const KM_GALLERY_SWIPE_ONBOARDING_SEEN = "kmGallerySwipeOnboardingSeen";

/** Device-level; do not clear on logout. */
export const FAVORITES_REMOVE_FROM_COMPARISON_WARNING_DISMISSED = "favoritesRemoveFromComparisonWarningDismissed";
